import { Box, CircularProgress, Button } from '@mui/material';
import React from 'react';
import DialogMediaPlayer from '../../../../../../DialogMediaPlayer/DialogMediaPlayer';
import { ReactPlayerProps } from 'react-player';
import usePractitionerControlsContext from '../../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { ImageUploadStyle } from './ImageUploadStyle';
import DefaultImage from '../../../../../../../assets/no_image.svg';
import { PLayerTriggeredBy } from '../../../../../../../commands/practitioner/enums/PLayerTriggeredBy';
import useUploadContext from '../../../../../../../hooks/useUploadContext/useUploadContext';
import UploadProgress from '../../../../../../UI/UploadProgress/UploadProgress';

interface ImageUploadProps {
  className?: string;
  index: number;
  value: number;
}

const ImageUpload = (props: ImageUploadProps) => {
  const { practitionerMediaURI, isMediaLoaded } = usePractitionerControlsContext();
  const { isLoading } = useUploadContext();
  const { imageTabContainer } = ImageUploadStyle;
  const { index, value } = props;

  const config = {
    youtube: {
      playerVars: {
        showinfo: 1,
        origin: window.location.origin,
      },
    },
  };

  const reactPlayerPreview: ReactPlayerProps = {
    url: practitionerMediaURI,
    width: '100%',
    height: '100%',
    config,
    controls: false,
  };

  return (
    <>
      {value === index && (
        <Box sx={imageTabContainer} role="tabpanel">
          <>
            {isLoading ? (
              <UploadProgress />
            ) : (
              <Box className={'image-container'}>
                {!!practitionerMediaURI && isMediaLoaded ? (
                  <DialogMediaPlayer
                    key={practitionerMediaURI}
                    ReactPlayerProps={reactPlayerPreview}
                    ReactPlayerTriggeredBy={PLayerTriggeredBy.Practitioner}
                  />
                ) : (
                  <Box className="image-default">
                    <img className={'img'} src={DefaultImage} alt="blanc-img" />
                  </Box>
                )}
              </Box>
            )}
          </>
        </Box>
      )}
    </>
  );
};

export default ImageUpload;
